/** One focus-point slider for the "today" photo on /admin/team; saves when released. */
export const FocusSlider = ({ axis, value, onChange, onCommit, disabled, memberKey }) => {
  const vertical = axis === "y";
  const commit = (e) => onCommit(Number(e.target.value));
  return (
    <label className={`block ${disabled ? "opacity-50" : ""}`}>
      <span className="flex items-center justify-between text-[11px] font-semibold uppercase tracking-[0.18em] text-olive">
        {vertical ? "Vertical focus" : "Horizontal focus"} <span className="font-mono text-ink">{value}%</span>
      </span>
      <span className="mt-2 flex items-center gap-2 text-[10px] uppercase tracking-[0.14em] text-olive/80">
        <span className="w-8">{vertical ? "top" : "left"}</span>
        <input
          type="range" min="0" max="100" step="5" value={value} disabled={disabled}
          onChange={(e) => onChange(Number(e.target.value))}
          onMouseUp={commit} onTouchEnd={commit} onKeyUp={commit}
          className="w-full accent-ink"
          data-testid={`team-photo-focus${vertical ? "" : "-x"}-${memberKey}`}
          aria-label={`${vertical ? "Vertical" : "Horizontal"} focus point for the today photo`}
        />
        <span className="w-8 text-right">{vertical ? "bottom" : "right"}</span>
      </span>
    </label>
  );
};
